/** Browser-safe audience helpers for the editor (no node:crypto). */
import type { SurveyAudience } from "./types";

/** Short chips for the editor / list ("Active ≤30d", "20+ expenses", …). */
export function describeAudience(a: SurveyAudience): string[] {
  const out: string[] = [];
  if (a.activeWithinDays != null) out.push(`Active ≤${a.activeWithinDays}d`);
  if (a.inactiveForDays != null) out.push(`Inactive ${a.inactiveForDays}d+`);
  if (a.minExpenses != null) out.push(`${a.minExpenses}+ expenses`);
  if (a.minAccountAgeDays != null) out.push(`Account ≥${a.minAccountAgeDays}d`);
  if (a.maxAccountAgeDays != null) out.push(`New ≤${a.maxAccountAgeDays}d`);
  if (a.group === "shared") out.push("In a shared group");
  if (a.group === "personal_only") out.push("Personal only");
  if (a.platforms && a.platforms.length === 1) out.push(a.platforms[0] === "ios" ? "iOS" : "Android");
  if (a.minAppVersion) out.push(`v${a.minAppVersion}+`);
  if (a.languages && a.languages.length === 1) out.push(a.languages[0] === "hi" ? "Hindi" : "English");
  if (a.samplePercent != null && a.samplePercent < 100) out.push(`${a.samplePercent}% sample`);
  return out.length ? out : ["Everyone"];
}

/** Admin preset cards (UI sugar over the filters above). */
export const AUDIENCE_PRESETS: readonly {
  id: string;
  label: string;
  description: string;
  apply: SurveyAudience;
}[] = [
  { id: "everyone", label: "Everyone", description: "All signed-in users", apply: {} },
  { id: "active", label: "Active users", description: "Opened app in last 30 days", apply: { activeWithinDays: 30 } },
  { id: "inactive", label: "Inactive 14+ days", description: "Why did they stop?", apply: { inactiveForDays: 14 } },
  { id: "power", label: "Power users", description: "20+ expenses logged", apply: { minExpenses: 20 } },
  { id: "shared", label: "In a shared group", description: "Member of a shared group", apply: { group: "shared" } },
  { id: "personal", label: "Personal only", description: "No shared group yet", apply: { group: "personal_only" } },
  { id: "new", label: "New users", description: "Signed up ≤ 14 days ago", apply: { maxAccountAgeDays: 14 } },
  { id: "hindi", label: "Hindi users", description: "App language Hindi", apply: { languages: ["hi"] } },
] as const;
